import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';

import { GlobalStyleTheme1, GlobalStyleTheme2, GlobalStyleTheme3 } from './styles';
import { theme1, theme2, theme3 } from './themes';
import { Theme } from './types';

export interface BaseProviderProps {
  theme?: any;
  themeName?: Theme;
  children: ReactNode;
}

const THEMES = [theme1, theme2, theme3];

const BaseThemeProvider = ({ theme, themeName, children }: BaseProviderProps) => {
  const currentTheme = THEMES.find((item: any) => item.name === (themeName || theme.name));

  return (
    <React.Fragment>
      {(themeName || theme.name) === Theme.theme1 && <GlobalStyleTheme1 />}
      {(themeName || theme.name) === Theme.theme2 && <GlobalStyleTheme2 />}
      {(themeName || theme.name) === Theme.theme3 && <GlobalStyleTheme3 />}
      <ThemeProvider theme={currentTheme || theme1}>{children}</ThemeProvider>
    </React.Fragment>
  );
};

export default BaseThemeProvider;
